const STORAGE_PREFIX = 'aivideoclip_publish_checklist_';

function storageKey(taskId) {
  return `${STORAGE_PREFIX}${taskId}`;
}

export function loadPublishChecklist(taskId) {
  if (!taskId) return {};
  try {
    const raw = localStorage.getItem(storageKey(taskId));
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
}

export function savePublishChecklist(taskId, checklist) {
  if (!taskId) return;
  localStorage.setItem(storageKey(taskId), JSON.stringify(checklist || {}));
}

export function clipChecklistKey(clip) {
  return String(clip.id != null ? clip.id : clip.index);
}

export function isClipFullyPublished(checklist, clipKey, platformIds) {
  const entry = checklist[clipKey] || {};
  return platformIds.every(id => !!entry[id]);
}

export function isClipUnpublished(checklist, clipKey, platformIds) {
  return !isClipFullyPublished(checklist, clipKey, platformIds);
}

export function togglePlatform(checklist, clipKey, platformId, checked) {
  const next = { ...checklist };
  const entry = { ...(next[clipKey] || {}) };
  entry[platformId] = checked;
  next[clipKey] = entry;
  return next;
}
